import { render, staticRenderFns } from "./spinner-button.vue?vue&type=template&id=5ac5de43&scoped=true&"
import script from "./spinner-button.vue?vue&type=script&lang=js&"
export * from "./spinner-button.vue?vue&type=script&lang=js&"
import style0 from "./spinner-button.vue?vue&type=style&index=0&id=5ac5de43&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac5de43",
  null
  
)

export default component.exports